import React, { Component } from 'react';

class Web extends Component {

	//static BaseUrl = "http://localhost/shopping/";
	static BaseUrl = "http://websites.codxplore.com/ecom/";

	constructor(props) {
	    super(props);
	}
}

export default Web;